'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRoute = exports.REGEX_NUMERIC_ID_MATCH = exports.REGEX_GUID_MATCH = exports.REGEX_ANYTHING_MATCH = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.addNavigation = addNavigation;
exports.onRouteNavigation = onRouteNavigation;
exports.onNavigation = onNavigation;

var _effects = require('redux-saga/effects');

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _ScreenReducer = require('../components/screen/ScreenReducer');

var _ClickTracker = require('../services/ClickTracker');

var _SetScreenArgsAction = require('../components/screen/actions/SetScreenArgsAction');

var _SetScreenArgsAction2 = _interopRequireDefault(_SetScreenArgsAction);

var _SetScreenIdAction = require('../components/screen/actions/SetScreenIdAction');

var _SetScreenIdAction2 = _interopRequireDefault(_SetScreenIdAction);

var _NavigationResetAction = require('../components/screen/actions/NavigationResetAction');

var _NavigationResetAction2 = _interopRequireDefault(_NavigationResetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [addNavigation, onRouteNavigation, onNavigation].map(_regenerator2.default.mark);

var REGEX_ANYTHING_MATCH = exports.REGEX_ANYTHING_MATCH = '.+';
var REGEX_GUID_MATCH = exports.REGEX_GUID_MATCH = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
var REGEX_NUMERIC_ID_MATCH = exports.REGEX_NUMERIC_ID_MATCH = '\\d+';

/**
 * Returns the corresponding route given url path
 * @param {{ [name: string]: NavigationRoute }} routes
 * @param {string} path
 * @returns {NavigationRoute}
 */
var getRoute = exports.getRoute = function getRoute(routes, path) {
  // use regex to find corresponding route
  for (var key in routes) {
    if (routes.hasOwnProperty(key)) {
      var route = routes[key];

      var regex = new RegExp(route.regex || route.path + '$', 'g'); // $ = regex exact match

      if (regex.test(path)) {
        return route;
      }
    }
  }

  return undefined;
};

/**
 * Logs navigation track and updates screenId
 * @param {string} screenId 
 * @param {any} [args]
 * @param {string} [source] 
 */
function addNavigation(screenId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return _regenerator2.default.wrap(function addNavigation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          // add navigation click track
          (0, _ClickTracker.addNavigationTrack)(screenId, source);

          // set new screen args

          if (!args) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return (0, _effects.put)((0, _SetScreenArgsAction2.default)([], args));

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _SetScreenIdAction2.default)(screenId));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
};

/**
 * Determines route navigation and clears current screen state and updates it for route navigation
 * @param {{ [name: string]: NavigationRoute }} routes
 * @param {string} path 
 * @param {any} [args] 
 */
function onRouteNavigation(routes, path) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var route, screenId;
  return _regenerator2.default.wrap(function onRouteNavigation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          // get corresponding route information
          route = getRoute(routes, path);

          if (route) {
            _context2.next = 3;
            break;
          }

          return _context2.abrupt('return');

        case 3:
          screenId = route.id;
          _context2.next = 6;
          return (0, _effects.call)(onNavigation, screenId, args);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
};

/**
 * Clears current screen state and updates it for next screen navigation
 * @param {string} screenId 
 * @param {any} [args] 
 * @param {string} [source]
 */
function onNavigation(screenId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var state, prevId;
  return _regenerator2.default.wrap(function onNavigation$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          state = (0, _Store2.default)().getState();
          prevId = (0, _ScreenReducer.getScreenId)(state.screen);

          // check if already on desired screen

          if (!(screenId === prevId)) {
            _context3.next = 4;
            break;
          }

          return _context3.abrupt('return');

        case 4:
          _context3.next = 6;
          return (0, _effects.put)((0, _NavigationResetAction2.default)());

        case 6:
          _context3.next = 8;
          return (0, _effects.call)(addNavigation, screenId, args, source || prevId);

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/NavigationService.js
// module id = 365
// module chunks = 10